<template lang="pug">
  div
    b-dropdown.export-dropdown( variant="button")
      template(#button-content)
        b-icon(icon ="box-arrow-in-right").mr-2
        span.font-weight-bold Exportar
      b-dropdown-text.export-text Exportar:
      //- b-dropdown-item(@click="exportAll()")
      //-   b-icon(icon ="box-arrow-in-right").mr-2
      //-   | Todo
      b-dropdown-item(@click="exportCurrentView()")
        b-icon(icon ="box-arrow-in-right").mr-2
        | Vista Actual
      b-dropdown-item(@click="showExportRangeModal = true")
        b-icon(icon ="calendar3").mr-2
        | Rango de Fecha
      b-dropdown-item(@click="showExportFromFileModal = true")
        b-icon(icon ="calendar3").mr-2
        | Desde archivo de OTs
    b-modal#export-range-modal(v-model="showExportRangeModal" title="Exportar Rango Fechas" hide-footer)
      .d-flex.align-items-center.mb-4
        span.mr-2 Fecha de creación
        b-form-checkbox(v-model="date_type" name="check-button" switch)
          | Fecha de conclusión
      b-form-group
        label.label-color Desde
        b-form-datepicker(v-model ="start_date")
      b-form-group
        label.label-color Hasta
        b-form-datepicker(v-model="end_date")
      div.row
        div.col.p-2.d-flex.flex-row.justify-content-end
          b-button(
            @click="closeModal()"
            variant="outline-danger"
          ) Cancelar
          b-button.ml-2(
            @click="exportExcel()"
            variant="button"
          ) Exportar

    //- TODO: mover estos modals a componentes
    b-modal#export-file-modal(v-model="showExportFromFileModal" title="Exportar desde archivo" hide-footer)
      .bg-grey.mb-3.px-3.py-2.border.rounded
        .d-flex.gap-3.align-items-center
          b-avatar(variant="info" size="2rem")
            b-icon(font-scale="1.5" icon="info")
          div.text-justify
            | El archivo ingresado debe tener una columna de datos con uno de los siguientes textos
            | en la primera celda: OT, RMA, N_SERIE
      b-dropdown.mb-2( variant="button" size="sm" menu-class="w-100 dropdown-menu" text="Descargar Plantilla")
        b-dropdown-item(@click="downloadTemplate('OT')") OT
        b-dropdown-item(@click="downloadTemplate('RMA')") RMA
        b-dropdown-item(@click="downloadTemplate('N_SERIE')") N° de Serie
      b-form-group
        label.label-color Seleccionar archivo
        b-form-file(
          v-model="inputFile"
          accept=".xlsx, .xls"
          placeholder="Archivo"
          @input=""
        )
      b-form-group
        label.label-color Seleccionar campos
        TagsFilter.fields-filter(
          v-model="inputFields"
          :options="fieldOptions"
          idKey="field"
          labelKey="label"
          input-id="fields-selector"
          selectorLabel="Seleccionar campos"
        ).mb-2
      div.row
        div.col.p-2.d-flex.flex-row.justify-content-end
          b-button(
            @click="showExportFromFileModal = false"
            variant="outline-danger"
          ) Cancelar
          b-button.ml-2(
            @click="exportFromFile"
            variant="button"
          ) Exportar

</template>

<script>
import { mapActions } from 'vuex'
import TagsFilter from '@/components/Shared/TagsFilter.vue'

export default {
  name: 'DownloadOTs',
  components: {
    TagsFilter,
  },
  props: ['otsFiltered'],
  data() {
    return {
      showExportRangeModal: false,
      start_date: null,
      end_date: null,
      showExportFromFileModal: false,
      inputFile: null,
      inputFields: [],
      fieldOptions: [],
      date_type: false
    }
  },
  watch: {
    showExportFromFileModal(val) {
      if (!val) {
        this.inputFile = null
        this.inputFields = []
        return
      }
      this.getExcelFields().then((res) => {
        this.fieldOptions = res.data
      })
    },
  },
  methods: {
    ...mapActions('OTStore', [
      'OTExcelAll',
      'OTExcelSelected',
      'OTExcellByDate',
      'OTExcelFromFile',
      'getExcelFields',
      'getExcelPlantilla',
    ]),
    closeModal() {
      this.start_date = null
      this.end_date = null
      this.showExportRangeModal = false
    },
    async downloadTemplate (type) {
      const resp = await this.getExcelPlantilla( type )
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `plantilla_${type}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    async exportAll() {
      const resp = await this.OTExcelAll()
      this.$bvToast.toast(resp.data, {
        variant: 'success',
      })
    },
    async exportCurrentView() {
      const resp = await this.OTExcelSelected(this.otsFiltered.join(','))
      this.$bvToast.toast(resp.data, {
        variant: 'success',
      })
    },
    async exportExcel() {
      const date = {
        fecha_inicio: this.start_date,
        fecha_final: this.end_date,
        tipo: this.date_type ? 'conclusion' : 'creacion',
      }
      const resp = await this.OTExcellByDate(date)
      this.$bvToast.toast(resp.data, {
        variant: 'success',
      })
      this.closeModal()
    },
    async exportFromFile() {
      const payload = {
        file: this.inputFile,
        fields: this.inputFields.map((f) => f.field).join(','),
      }
      this.OTExcelFromFile(payload).then((resp) => {
        this.$bvToast.toast(resp.data, {
          variant: 'success',
        })
        this.showExportFromFileModal = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

::v-deep .form-group label {
  color: $samtek-grey !important;
  font-weight: bold;
}

.export-dropdown {
  ::v-deep .btn {
    display: inline-flex;
    align-items: center;
    height: 45px;
    padding: 0 16px;
    border: none;
    border-radius: 8px;
    background-color: $samtek-yellow;
    color: $samtek-black;
    font-size: 15px;
    font-weight: 600;

    &:hover,
    &:focus {
      background-color: #F5C400;
      color: $samtek-black;
    }
  }

  ::v-deep .btn .b-icon {
    color: $samtek-black;
    font-size: 16px;
    vertical-align: middle;
  }

  ::v-deep .dropdown-toggle::after {
    border-top-color: $samtek-black;
  }

  ::v-deep .dropdown-menu.show {
    margin-top: 4px;
    padding: 4px 0;
    border: 1px solid $table-head-bg;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  }

  ::v-deep .dropdown-item {
    padding: 10px 16px;
    font-size: 14px;
    color: $samtek-black;

    &:hover,
    &:focus {
      background-color: $center-bg;
      color: $samtek-black;
    }
  }

  ::v-deep .b-dropdown-text {
    padding: 10px 16px;
    font-size: 12px;
    color: $samtek-grey;
  }
}

#export-range-modal,
#export-file-modal {
  ::v-deep .modal-content {
    padding: 20px;
    border: none;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  }

  ::v-deep .modal-header {
    padding: 0 0 20px;
    border-bottom: none;
    background-color: #fff;
  }

  ::v-deep .modal-title {
    font-size: 18px;
    font-weight: 700;
    color: $samtek-black;
  }

  ::v-deep .close {
    color: $samtek-grey;
    opacity: 1;
    text-shadow: none;

    &:hover {
      color: $danger-strong;
    }
  }

  ::v-deep .modal-body {
    padding: 0 !important;
  }

  ::v-deep .btn {
    height: 45px;
    padding: 0 16px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
  }

  ::v-deep .btn-outline-danger {
    border: 1px solid $table-head-bg;
    background-color: #fff;
    color: $samtek-black;

    &:hover,
    &:focus {
      border-color: $table-head-bg;
      background-color: $center-bg;
      color: $samtek-black;
    }
  }

  ::v-deep .btn-button {
    border-color: $samtek-yellow;
    background-color: $samtek-yellow;
    color: $samtek-black;

    &:hover,
    &:focus {
      border-color: #F5C400;
      background-color: #F5C400;
      color: $samtek-black;
    }
  }
}

.fields-filter::v-deep {
  .dropdown-menu {
    max-height: calc(90vh - 380px) !important;
  }
}
</style>
